import type React from 'react';
import { ListSubheader, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
`;

export const LibraryLinkRow = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
`;

export const LibraryLink = styled(Link)`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledGroupHeader = styled(ListSubheader)<{ component?: React.ElementType }>`
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  font-weight: 600;
  line-height: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const GroupOptions = styled.ul`
  padding: 0;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
